export var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["TICKETING"] = 10] = "TICKETING";
    ActivityType[ActivityType["CALL_CENTER"] = 20] = "CALL_CENTER";
    ActivityType[ActivityType["CHAT"] = 30] = "CHAT";
    ActivityType[ActivityType["FACEBOOK"] = 40] = "FACEBOOK";
    ActivityType[ActivityType["WHATSAPP"] = 50] = "WHATSAPP";
    ActivityType[ActivityType["SMS"] = 60] = "SMS";
    ActivityType[ActivityType["KNOWLEDGEBASE"] = 70] = "KNOWLEDGEBASE";
    ActivityType[ActivityType["TWITTER"] = 80] = "TWITTER";
    ActivityType[ActivityType["INSTAGRAM"] = 90] = "INSTAGRAM";
})(ActivityType || (ActivityType = {}));
//# sourceMappingURL=index.js.map